import { render, staticRenderFns } from "./honorsList.vue?vue&type=template&id=a51fd824&scoped=true"
import script from "./honorsList.vue?vue&type=script&lang=js"
export * from "./honorsList.vue?vue&type=script&lang=js"
import style0 from "./honorsList.vue?vue&type=style&index=0&id=a51fd824&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51fd824",
  null
  
)

export default component.exports